export enum MessageType {
  Public = 'Public',
  Internal = 'Internal',
}
